import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListChannelContainer = styled.div<React.CSSProperties>`
  align-items: center;
  cursor: pointer;
  display: flex;
  margin-bottom: ${24 * Screen.widthRatio}px;
  white-space: nowrap;
`;

export default ChannelListChannelContainer;
